export default class CatchmentPointDto {
    constructor(obj) {
        this.id = obj.id // Int
        this.code = obj.code // String
        this.codeWithoutDesignation = obj.code.split('/')[0]
        this.owner = obj.owner // Option[Int]
        this.mainPoint = obj.mainPoint // Option[Boolean]
    }
}